// Quiet-hours bounds travel as minutes after local midnight (0-1439);
// the settings screen shows them as HH:MM. Pure so the conversion is
// tested without a screen.
const HALF_HOUR = 30;
const MINUTES_PER_DAY = 1440;

export function minutesToTime(minutes: number): string {
  const hh = String(Math.floor(minutes / 60)).padStart(2, '0');
  const mm = String(minutes % 60).padStart(2, '0');

  return `${hh}:${mm}`;
}

export function timeToMinutes(time: string): number {
  const [hh, mm] = time.split(':').map(Number);

  return hh * 60 + mm;
}

// Every half hour of the day -- the granularity the picker offers.
export function quietHourOptions(): number[] {
  return Array.from({ length: MINUTES_PER_DAY / HALF_HOUR }, (_, i) => i * HALF_HOUR);
}
